import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mwo-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
/**
 * TODO :: in the long run, simplified the view of this component.
 * It is currently containing a lot of useless css class and code.
 * However this is not a priority
 */
export class HelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
